/**
 * Drawing Price Lines & Options Builders.
 *
 * Constructs Lightweight Charts price line options for horizontal line drawings.
 */

export interface DrawingPriceLineLike {
  price?: number;
  color?: string;
  opacity?: number;
  lineWidth?: number;
  lineStyle?: number;
  title?: string;
  [key: string]: any;
}

export interface PriceLineOptions {
  price: number;
  color: string;
  lineWidth: number;
  lineStyle: number;
  axisLabelVisible: boolean;
  title: string;
}

/**
 * Builds price line configuration options from a drawing record.
 */
export function buildPriceLineOptions(
  drawing: DrawingPriceLineLike,
  hexToRgba: (hex: string, alpha: number) => string,
): PriceLineOptions {
  const price = drawing.price ?? 0;
  const color = hexToRgba(drawing.color || "#787B86", drawing.opacity ?? 1);
  const lineWidth = drawing.lineWidth || 1;
  const lineStyle = drawing.lineStyle !== undefined ? drawing.lineStyle : 0;
  const title = drawing.title || "";

  return {
    price,
    color,
    lineWidth,
    lineStyle,
    axisLabelVisible: true,
    title,
  };
}
